import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { focusInput } from '../lib/AllGlobalFunction'

const ModelComponent = ({
  onClick,
  validationSchema,
  onSubmit,
  formik,
  ...props
}) => {
  const validateForm = async () => {
    const { values, setErrors, setTouched, resetForm } = formik
    try {
      await validationSchema.validate(values, { abortEarly: false })

      setErrors({})
      setTouched({})

      onSubmit(values, resetForm)
    } catch (validationErrors) {
      const errors = {}
      validationErrors.inner.forEach((error) => {
        errors[error.path] = error.message
      })
      setErrors(errors)

      setTouched(
        Object.keys(values).reduce((acc, key) => {
          acc[key] = true
          return acc
        }, {})
      )

      focusInput(Object.keys(errors)[0])
      if (Object.keys(errors)[0] === 'pageContent') {
        values?.pageContentEditor?.editing.view.focus()
      }
    }
  }

  return (
    <Modal
      {...props}
      size={props.modalsize || 'lg'}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={props.modalheaderclass || 'fw-semibold'}
        >
          {props.modeltitle || 'Default Modal Title'}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>{props.children}</Modal.Body>

      <Modal.Footer className={props.footerclass || ''}>
        {/* {props.footer} */}

        {props?.formbuttonid || onSubmit ? (
          <>
            {onSubmit && props.formbuttonid ? (
              <Button
                variant={props.closebtnvariant || 'primary'}
                onClick={validationSchema ? validateForm : onSubmit}
              >
                {props.submitname || 'Save'}
              </Button>
            ) : (
              props.formbuttonid && (
                <Button
                  variant={props.closebtnvariant || 'primary'}
                  type={'submit'}
                  form={props.formbuttonid || ''}
                >
                  {props.submitname || 'Save'}
                </Button>
              )
            )}
            <Button
              variant={props.closebtnvariant || 'light'}
              onClick={props.onHide}
            >
              {props.btnclosetext || 'Close'}
            </Button>
          </>
        ) : (
          !props?.closebtnshow && (
            <Button
              variant={props.closebtnvariant || 'light'}
              onClick={props.onHide}
            >
              {props.btnclosetext || 'Close'}
            </Button>
          )
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ModelComponent
